import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Seo({ title, description, children }) {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {children}
    </Helmet>
  );
}
